<template>
  <aside class="cart-details">
    <ul v-if="hasItems" class="cart-items plain">
      <li v-for="item in items" :key="item.product.id">
        <span class="quantity">{{item.quantity}}</span>
        <span class="name selectable" @click="showProductPage(item.product.id)">
          {{item.product.name}}
          <em
            v-if="itemHasOptions(item)"
            class="options"
          >{{renderItemOptions(item)}}</em>
        </span>
        <span class="price" :title="item.product.price|currencyExclVAT">{{calcPrice(item)}}</span>
      </li>
      <li class="total" :title="subtotalVATText">
        <span class="name">{{labels.total}}</span>
        <span class="price gross">{{total|currency}}</span>
      </li>
    </ul>
    <slot></slot>
  </aside>
</template>
<script>
import { mapGetters } from "vuex";
import filters from "../mixins/filters";

export default {
  name: "Cart",
  mixins: [filters],
  computed: {
    ...mapGetters(["cart", "products", "subtotal", "tax", "labels", "total"]),
    items() {
      let items = [];
      if (this.cart) {
        if (this.cart.items) {
          if (this.cart.items instanceof Array) {
            items = this.cart.items.filter(item => {
              let valid = false;
              if (typeof item === "object") {
                valid = item.hasOwnProperty("product");
              }
              return valid;
            });
          }
        }
      }
      return items;
    },
    hasItems() {
      return this.items.length > 0;
    },
    subtotalVATText() {
      return (
        this.labels.vat +
        ":" +
        this.prependCurrency(this.tax) +
        "," +
        this.labels.subtotal +
        ":" +
        this.prependCurrency(this.subtotal)
      );
    }
  },
  methods: {
    showProductPage(productId) {
      if (productId) {
        const pg = this.products.find(p => p.productId === productId);
        if (pg) {
          if (this.$route.path !== pg.routerLink) {
            this.$router.push(pg.routerLink);
          }
        }
      }
    },
    itemHasOptions(item) {
      if (item.options) {
        if (typeof item.options === "object") {
          return Object.keys(item.options).length > 0;
        }
      }
      return false;
    },
    renderItemOptions(item) {
      let str = "";
      let strs = [];
      if (this.itemHasOptions(item)) {
        let keys = Object.keys(item.options);
        for (let i = 0; i < keys.length; i++) {
          let k = keys[i];
          strs.push(`${k}: ${item.options[k]}`);
        }
        str = strs.join(", ", strs);
      }
      return str;
    },
    calcPrice(item) {
      let price = 0;
      if (item.product) {
        if (item.product.priceGross) {
          price = item.product.priceGross;
          if (typeof item.options === "object") {
            let keys = Object.keys(item.options);
            if (keys.length > 0) {
              let p = this.products.find(p => p.productId === item.product.id);
              if (p) {
                if (p.options) {
                  let rate = this.calcRate(p);
                  for (let i = 0; i < keys.length; i++) {
                    let k = keys[i];
                    let opt = p.options.find(op => op.name === k);
                    if (opt) {
                      let choice = opt.choices.find(
                        c => c.text === item.options[k]
                      );
                      if (choice) {
                        price += choice.priceModifier * rate;
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
      return this.prependCurrency(price);
    }
  }
};
</script>